/**
 * SharedWithMeCard - Shows users who share reflections with the current user
 *
 * Displays a list of sharers with total and new (unviewed) reflection counts.
 * Clicking navigates to the prompts page filtered by that user.
 */

import React from 'react';

function SharedWithMeCard({ sharedWithMe, onNavigateToUser, onNavigateToUserNewOnly }) {
  if (!sharedWithMe || sharedWithMe.length === 0) {
    return null; // Don't show card if no one shares with user
  }

  return (
    <div className="bento-card bento-card--small">
      <div className="bento-card-header">
        <h2 className="bento-card-title">
          <span className="bento-card-icon">👥</span>
          Shared With Me
        </h2>
      </div>
      <div className="shared-with-me-list">
        <div className="shared-with-me-header">
          <span className="shared-header-name">From</span>
          <span className="shared-header-total">Total</span>
          <span className="shared-header-new">New</span>
        </div>
        {sharedWithMe.map(sharer => (
          <div key={sharer.userId} className="shared-with-me-item">
            <span
              className="shared-username"
              onClick={() => onNavigateToUser(sharer.username)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onNavigateToUser(sharer.username);
                }
              }}
            >
              {sharer.username}
            </span>
            <span
              className="shared-total-count"
              onClick={() => onNavigateToUser(sharer.username)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onNavigateToUser(sharer.username);
                }
              }}
            >
              {sharer.totalCount}
            </span>
            <span
              className={`shared-new-count ${sharer.newCount > 0 ? 'has-new' : ''}`}
              onClick={() => sharer.newCount > 0 && onNavigateToUserNewOnly(sharer.username)}
              role={sharer.newCount > 0 ? 'button' : undefined}
              tabIndex={sharer.newCount > 0 ? 0 : -1}
              onKeyDown={(e) => {
                if (sharer.newCount > 0 && (e.key === 'Enter' || e.key === ' ')) {
                  e.preventDefault();
                  onNavigateToUserNewOnly(sharer.username);
                }
              }}
            >
              {sharer.newCount > 0 ? sharer.newCount : '—'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SharedWithMeCard;
